import { Banks, NORNE_CENTERID } from "@portal/assets/banks";

export const GetBankName = (centerId: string | undefined) => {
  if (centerId == undefined || centerId === "") centerId = NORNE_CENTERID;
  return Banks.get(centerId);
};
